import { LegalLayout } from "../components/LegalLayout";
import { usePageSEO } from "../hooks/usePageSEO";

export default function Impressum() {
  usePageSEO({
    title: "Impressum — Alphalane Trading Systems",
    description: "Impressum und Haftungsausschluss von Alphalane Trading Systems / Moonshine Solutions GmbH.",
    canonical: "https://alphalane-tradingsystems.com/impressum",
  });
  return (
    <LegalLayout title="Impressum & Haftungsausschluss" lastUpdated="Mai 2026">
      <h2>Inhaberin dieses Portals und verantwortlich für den Inhalt</h2>
      <p>
        <strong>Moonshine Solutions GmbH</strong><br />
        Venusweg 42<br />
        3185 Schmitten FR<br />
        Schweiz
      </p>
      <p>
        Telefon: +41&nbsp;79&nbsp;950&nbsp;16&nbsp;46<br />
        E-Mail: <a href="mailto:kontakt@moonshine-solutions.com">kontakt@moonshine-solutions.com</a>
      </p>

      <h2>Vertreten durch</h2>
      <p>Pascal Schwab, Geschäftsführer der Moonshine Solutions GmbH</p>

      <h2>Handelsregister-Eintrag</h2>
      <p>
        Eingetragener Firmenname: Moonshine Solutions GmbH<br />
        Handelsregister-Nr.: <a href="https://www.uid.admin.ch/Detail.aspx?uid_id=CHE381126379" target="_blank" rel="noopener noreferrer">CHE-381.126.379</a>
      </p>

      <p>
        Es wird darauf hingewiesen, dass die Sicherheit der Kommunikation über Internet oder E-Mail nicht gewährleistet ist.
        Jegliche Haftung für Verletzungen des Berufsgeheimnisses, bedingt durch die Kommunikation über Internet oder E-Mail,
        wird abgelehnt. Für vertrauliche und wichtige Mitteilungen empfehlen wir die Übermittlung mittels Post- oder Kuriersendung.
      </p>

      <h2>Haftungsausschluss</h2>
      <p>
        Diese Website wurde mit grösstmöglicher Sorgfalt zusammengestellt. Trotzdem kann für die Fehlerfreiheit und Genauigkeit
        der enthaltenen Informationen nicht garantiert werden. Die Moonshine Solutions GmbH schliesst jegliche Haftung für Schäden,
        die direkt oder indirekt aus der Benutzung dieser Website entstehen, aus, soweit diese nicht auf Vorsatz oder grober
        Fahrlässigkeit der Moonshine Solutions GmbH beruhen.
      </p>
      <p>
        Die Informationen auf dieser Website stellen <strong>keine Finanzberatung</strong> dar. Alle bereitgestellten Informationen
        dienen ausschliesslich Informationszwecken und stellen keine Empfehlung oder Aufforderung zum Kauf, Verkauf oder Halten
        von Wertpapieren, Finanzprodukten oder Investitionen dar.
      </p>
      <p>
        Wir sind keine Finanzberater und geben keine finanziellen Ratschläge, Empfehlungen oder Garantien in Bezug auf die Eignung,
        Rendite oder Angemessenheit von Finanzprodukten oder Investitionen ab. Jegliche Entscheidungen, die auf Grundlage der
        Informationen auf dieser Website oder im persönlichen Gespräch getroffen werden, liegen in der alleinigen Verantwortung
        des Nutzers.
      </p>
      <p>
        Wir empfehlen dringend, dass Sie vor jeglichen finanziellen Entscheidungen professionelle Finanzberatung von einem
        qualifizierten Finanzberater oder einer anderen autorisierten Fachperson einholen. Die Verwendung der Informationen
        erfolgt auf eigenes Risiko.
      </p>
      <p>
        Wir übernehmen keine Haftung für Verluste oder Schäden, die durch die Verwendung der Informationen entstehen können.
        Wir haften nicht für etwaige Handlungen, die auf der Grundlage der Informationen ausgeführt werden.
      </p>
      <p>
        Wir behalten uns das Recht vor, den Inhalt dieser Website jederzeit und ohne vorherige Ankündigung zu ändern, zu modifizieren oder zu löschen.
      </p>
      <p>
        Durch die Nutzung erklären Sie sich mit diesem Haftungsausschluss einverstanden. Bei Fragen zu diesem Haftungsausschluss
        können Sie uns unter den oben genannten Kontaktinformationen kontaktieren.
      </p>

      <h2>Externe Verweise und Links</h2>
      <p>
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt
        der verlinkten Seiten sind ausschliesslich deren Betreiber verantwortlich.
      </p>
    </LegalLayout>
  );
}
